import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: 'https://4e7751f7e32a4c53890eb114f1262dee@o790401.ingest.sentry.io/5822365',
  environment: process.env.SENTRY_ENV,
});
